import { alpha, createTheme } from '@mui/material/styles';
import type { PaletteOptions } from '@mui/material/styles';
import { baseThemeOptions } from './theme.base';
import type { PaletteCustom } from './theme.d';

const backgroundDefault = '#F5F5F5';

const custom: PaletteCustom = {
  border: {
    primary: '#E0E0E0',
    secondary: '#EDEDED',
  },
  layout: {
    workspace: '#FEFEFE',
    shell: {
      buttonHover: '#EDEDED',
      buttonSelected: '#E0E0E0',
    },
  },
  overlay: 'rgba(36, 36, 36, 0.25)',
  teceo: {
    blue: '#3366FF',
    orange: '#FF703D',
    green: '#00DAAD',
  },
  category: {
    orange: '#fd6a4c',
    blue: '#3467fe',
    green: '#00cca2',
  },
  backdrop: alpha(backgroundDefault, 0.8),
  status: {
    neutral: '#757575',
    waiting: '#fc6b4b',
    progress: '#3366ff',
    success: '#00cba1',
    successStrong: '#005443',
    error: '#f44336',
    closed: '#020202',
    inactive: '#424242',
  },
  gradients: {
    rachelGlow: 'linear-gradient(-75deg, #FC6B4B 10%, #4876FF 85%)',
    rachelMark: 'linear-gradient(90deg, #FC6B4B 0%, #4876FF 100%)',
    secondaryButton: 'linear-gradient(180deg, #EAEAEA 0%, #D9DADB 100%)',
    secondaryButtonHover: 'linear-gradient(180deg, #E4E4E4 0%, #D4D5D6 100%)',
  },
  chart: {
    series: ['#3366FF', '#FF703D', '#F7B0A1', '#C2D1FF', '#00DAAD', '#FFB020', '#9C6ADE'],
    seriesOpacities: [1, 0.65, 0.4],
    lineGradient: {
      from: '#3366FF',
      to: '#FF703D',
    },
  },
};

const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#FC6B4B',
    light: '#F7B0A1',
    dark: '#F94A20',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#F8F8F8',
    dark: '#EDEDED',
    contrastText: '#242424',
  },
  accent: {
    main: '#424242',
    light: '#9E9E9E',
    dark: '#242424',
    contrastText: '#FFFFFF',
  },
  background: {
    default: backgroundDefault,
    paper: '#FFFFFF',
    contrast: '#F8F8F8',
  },
  text: {
    primary: '#242424',
    secondary: '#616161',
    tertiary: '#9E9E9E',
    disabled: '#BDBDBD',
  },
  action: {
    active: '#BDBDBD',
    hover: '#F8F8F8',
    selected: '#EDEDED',
    disabled: '#F8F8F8',
    disabledBackground: '#FAFAFA',
    focus: '#FAFAFA',
  },
  error: { main: '#D32F2F', dark: '#C62828', light: '#ffebee', contrastText: '#FFFFFF' },
  warning: { main: '#F57C00', dark: '#E65100', light: '#fff2e1', contrastText: '#FFFFFF' },
  info: { main: '#0288D1', dark: '#01579B', light: '#e1f5fe', contrastText: '#FFFFFF' },
  success: { main: '#2E7D32', dark: '#1B5E20', light: '#e9f5e9', contrastText: '#FFFFFF' },
  divider: '#EDEDED',
  custom,
};

const lightTheme = createTheme(baseThemeOptions, { palette: lightPalette });

export default lightTheme;
